import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Box
} from "@mui/material";
import { roleManagementStore } from "../../../../../app/stores/RoleManagement";
import { RoleManagementService } from "../../../../../services/supabase/RoleManagementService";
import toastService from "../../../../../services/toast/ToastService";
import { BasicButton } from "../../../../../components/BasicButton";

interface CreateRoleDialogProps {
    open: boolean;
    onClose: () => void;
}

export const CreateRoleDialog: React.FC<CreateRoleDialogProps> = ({ open, onClose }) => {
    const { isLoading } = roleManagementStore();
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const handleCreate = async () => {
        if (!name) {
            toastService.showError("Role name is required.");
            return;
        }

        const newRole = await RoleManagementService().createRole({ name, description });
        if (newRole) {
            toastService.showSuccess(`Role "${name}" created successfully.`);
            onClose();
            setName("");
            setDescription("");
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Create New Role</DialogTitle>
            <DialogContent>
                <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Role Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                    <TextField
                        margin="dense"
                        label="Description (Optional)"
                        type="text"
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={3}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
                <BasicButton 
                    title="Cancel" 
                    onClick={onClose}
                    variant="outlined"
                />
                <BasicButton 
                    title={isLoading ? "Creating..." : "Create Role"}
                    onClick={handleCreate} 
                    variant="contained" 
                    isLoading={isLoading}
                />
            </DialogActions>
        </Dialog>
    );
}; 